import { Component, OnInit, ViewChild } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { SidenavComponent, ToastService } from 'ng-uikit-pro-standard';
import { AppConstants } from '../config.service';
import { SharedService } from '../shared/shared.service';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public user: any;
  public userEmailAddress: any = {};
  public loggedInUserInitials: string;
  sprigSub: Subscription;
  roleAccessSubscription: Subscription;
  notificationCompCdnUrl: string;

  constructor(
    private keycloakService: KeycloakService,
    private appConstants: AppConstants,
    private sharedService: SharedService,
    private authService : AuthService,
    private translate: TranslateService,
    public toastr: ToastService
  ) 
  {
    this.userPreferenceCdnUrl =this.appConstants.endPoints.webComponentsEndPoint + 'user-preference-modal/user-preferences-modal.js'
    this.switchAppDropDownCdnUrl = this.appConstants.endPoints.webComponentsEndPoint + 'switch-app-dropdown/js/switch-app-dropdown.js';
    this.notificationCompCdnUrl = this.appConstants.endPoints.webComponentsEndPoint + 'notification-element/notification-component.js';

    this.sprigSub = this.authService.checksprigAvailable.subscribe(res => {
      if (res && res.sprigNotAvailable)
        this.showDocWarningModal(res)
    })

    this.roleAccessSubscription = this.authService.roleAccessSubscription.subscribe(data => {
      this.canShowHeader = data;
    })
  }

  @ViewChild('sidenav',{static:true}) sidenav : SidenavComponent
  
  dropDownSendData:any = {};
  switchAppDropDownCdnUrl : string
  notificationElementEndpoint : string
  canShowHeader : any = false;
  async ngOnInit() {
    if (await this.keycloakService.isLoggedIn()) {
      this.appConstants.checkAuth();
      const user = this.appConstants.userDetails;
      const token = await this.keycloakService.getToken();
      this.sendToken = {
        token: token
      };
      await this.appConstants.getTenantId();
      this.dropDownSendData = {
        url: this.appConstants.endPoints.tenantEndPoint + this.appConstants.tenantId + '/users/' + user.email + '/applications',
        params: {
        },
        imageBasePath : this.appConstants.endPoints.webComponentsEndPoint + 'switch-app-dropdown/images/app-icons/'            
      }

      setInterval(() => {
        this.getToken();
      }, 1000);

      this.userEmailAddress = user.email
      this.user = user.firstName + ' ' + user.lastName
      this.loggedInUserInitials = this.user.match(/\b(\w)/g).join('');
      this.notificationCount()
      let selectionInterval = setInterval(() => {
        this.notificationCount();
      }, this.appConstants.endPoints.notificationCountInterval)
      this.setUserPreferenceModalData();
    }
  }

  ngOnDestroy() {
    if (this.sprigSub)
      this.sprigSub.unsubscribe();
      if(this.roleAccessSubscription)
      this.roleAccessSubscription.unsubscribe()
  }

  public msgCount: number;
  notificationCount() {
    this.sharedService.get(this.appConstants.endPoints.notificationEndPoint + 'unread-count', { destinationAddress: this.userEmailAddress })
      .subscribe(data => {
        this.msgCount = data
      }, error => {

      });

  }

  async logout() {
    const localStorgeAttributes = [
      "isSprigEnabled",
      "selectedDevice",
      "accreditationId"
    ];
    for (let index = 0; index < localStorgeAttributes.length; index++) {
      const element = localStorgeAttributes[index];
      localStorage.removeItem(element);
    }
    await this.keycloakService.logout();
  }

  sprigWarningData: any = {}
  showDocWarningModal(obj) {
    this.sprigWarningData = { ...{}, ...obj }
  }


  notificationInfo: any = {};
  isDrawerOpen = false;

  async toggleShowDrawer() {
    this.isDrawerOpen = !this.isDrawerOpen;
    let notificationsData;
    if (this.isDrawerOpen) {
      const token = await this.keycloakService.getToken();
      notificationsData = {
        headers: {
          token: token,
          customerId: "",
        },
        unread: {
          url: this.appConstants.endPoints.notificationEndPoint + 'unread',
          params: { destinationAddress: this.userEmailAddress }
        },
        markAsRead: {
          url: this.appConstants.endPoints.notificationEndPoint + 'mark-as-read',
          params: { destinationAddress: this.userEmailAddress }
        },
        markAllRead: {
          url: this.appConstants.endPoints.notificationEndPoint + 'mark-all-read',
          params: { destinationAddress: this.userEmailAddress }
        }
      }
      notificationsData['isOpen'] = this.isDrawerOpen;
      this.notificationInfo = { ...{}, ...notificationsData };
    }
    else {
      this.notificationInfo = { isOpen: false };
    }
  }

  closeNotification(e) {
    this.isDrawerOpen = false;
  }

  openUserPreferencesModal(){
    //TODO:
    this.open()
  }

  sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }

  userPreferenceCdnUrl: string = "";
  endpoints: any = {}
  async setUserPreferenceModalData() {
    let token = await this.keycloakService.getToken();
    this.sendToken = Object.assign({}, {
      token: token
    })
    let endpoint = {
      appliances: this.appConstants.endPoints.sprigApiEndPoint + 'admin/',
      sprigEndPoints: this.appConstants.endPoints.sprigApiEndPoint,
    }
    this.endpoints = { ...{}, ...endpoint }  
  }

  userPreferencesData: any = {};
  async open() {
    const user = this.appConstants.userDetails;
    const token = await this.keycloakService.getToken();
    this.sendToken = {
      token: token
    };

    setInterval(() => {
      this.getToken();
    }, 1000);
    let endpoint = {
      schedulesEndpoint: this.appConstants.endPoints.schedulesEndpoint,
      samplesEndpoint: this.appConstants.endPoints.sampleTrackerEndpoint,
      tenantEndPoint: this.appConstants.endPoints.tenantEndPoint,
      messageNotificationEndPoint: this.appConstants.endPoints.notificationEndPoint,
      reportServicesEndPoint: this.appConstants.endPoints.reportServicesEndPoint,
      appliances: this.appConstants.endPoints.sprigApiEndPoint + 'admin/',
      sprigEndPoints: this.appConstants.endPoints.sprigApiEndPoint,
      resourcesEndPoint: this.appConstants.endPoints.resourcesEndPoint
    }
    let obj = {}
    obj['userInfo'] = this.appConstants.userDetails
    obj['endPoints'] = endpoint
    obj['showModal'] = true
    this.userPreferencesData = { ...{}, ...obj }
  }

  langChanged(lang) {
    if (lang && lang.detail)
      this.translate.use(lang.detail).subscribe(res => { },
        err => {
          this.toastr.warning(this.translate.instant('administration_langNotSupported_label'));
          this.translate.use('en');
          const userSettings = { preferredLanguageCode: 'en' };
          localStorage.setItem("userSettingsJson", JSON.stringify(userSettings));
        })
  }

  toastMessages(message) {
    if (message && message.detail) {
      let toastMessage = message.detail
      if (toastMessage && toastMessage.success)
        this.toastr.success(toastMessage.success)
      else 
        this.toastr.success(toastMessage.error.errorMessage)
    }
  }

  defaultSprigInfo: any = {}
  getSprigInfo(event) {
    if (event && event.detail) {
      this.defaultSprigInfo = { ...{}, ...event.detail }
    }
  }

}
